module.exports = "<app-payor-date-range-report reportPath=\"DuplicateModifiers\" reportName=\"Duplicatemodifiers.xlsx\" isExcel=\"true\" title=\"Report Duplicate Modifier\"></app-payor-date-range-report>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/manager-reports/duplicate-modifiers-report/duplicate-modifiers-report.component.html
// module id = 2464
// module chunks = 66